import { Spinner } from '@intigral/shared';
import { DetailOverlay } from './DetailOverlay';
import { __ } from '../../../translations';
import { Modal } from '../../../components/ui/Modal';
import { useOverlayAactions } from '../hooks/useOverlayAactions';

const MovieDetailsOverlayPage = () => {
    const {
        isVodLoading,
        isError,
        isVodError,
        selectedMovieId,
        vodData,
        seasons,
        episodes,
        promotionProviderImages,
        closeOverlay,
    } = useOverlayAactions();

    return (
        <Modal
            useFlexLayout={false}
            open={selectedMovieId !== null}
            onOpenChange={() => {
                closeOverlay();
                return;
            }}
            isLoading={isVodLoading}
            title={vodData?.text}
        >
            {(isVodError || isError) && __('overlay_movie_load_error')}
            {!isVodLoading && !vodData?.Id && __('overlay_movie_load_error')}
            {vodData?.Id && (
                <DetailOverlay
                    item={vodData}
                    seasons={seasons ?? []}
                    episodes={episodes ?? []}
                    promotionProviderImages={promotionProviderImages}
                />
            )}
        </Modal>
    );
};

export default MovieDetailsOverlayPage;
